import { render, staticRenderFns } from "./ConversationPane.vue?vue&type=template&id=1501a43e&scoped=true&"
import script from "./ConversationPane.vue?vue&type=script&lang=js&"
export * from "./ConversationPane.vue?vue&type=script&lang=js&"
import style0 from "./ConversationPane.vue?vue&type=style&index=0&id=1501a43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501a43e",
  null
  
)

export default component.exports